import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocalePlaceholderDirective } from '../../directives/localeplaceholder.directive';
import { LocaleByKeyPipe, ReplaceStringPipe } from '../../localePipe';
import { LocaleComponent } from '../Locale/locale.component';
import { LocalesService } from '../Locale/locales.service';


@NgModule({
  imports: [
    CommonModule
  ],
    declarations: [
      LocaleComponent,
      LocaleByKeyPipe,
      LocalePlaceholderDirective,ReplaceStringPipe],
    exports: [
      LocaleComponent,
      LocaleByKeyPipe,
      LocalePlaceholderDirective,ReplaceStringPipe
    ],
    providers: [
      LocalesService
    ]
})
export class LocaleModule { }
